import { updatedDiff } from '@helpers/data';

import { WithdrawalsSetPaymentSystemDistributionPercentReducer } from './types';

export const withdrawalsSetPaymentSystemDistributionPercentReducer: WithdrawalsSetPaymentSystemDistributionPercentReducer =
  (state, action) => {
    const { aggregatorId, paymentSystemId, distributionPercent } =
      action.payload;

    if (
      !paymentSystemId ||
      !state.withdrawalsDistributionSettingsProcessedItems ||
      !state.withdrawalsDistributionSettingsItems
    ) {
      return state;
    }

    const processed = {
      ...state.withdrawalsDistributionSettingsProcessedItems,
      [aggregatorId]: {
        ...state.withdrawalsDistributionSettingsProcessedItems[aggregatorId],
        paymentSystems: {
          ...(state.withdrawalsDistributionSettingsProcessedItems[aggregatorId]
            ?.paymentSystems ?? {}),
          [paymentSystemId]: {
            ...(state.withdrawalsDistributionSettingsProcessedItems[
              aggregatorId
            ]?.paymentSystems
              ? state.withdrawalsDistributionSettingsProcessedItems[
                  aggregatorId
                ]?.paymentSystems[paymentSystemId]
              : {}),
            distributionPercent,
          },
        },
      },
    };

    const changes = updatedDiff(
      state.withdrawalsDistributionSettingsItems,
      processed
    );

    return {
      ...state,
      withdrawalsDistributionSettingsProcessedItems: {
        ...changes,
      },
    };
  };
